import React, { Component } from 'react';

class ColorPicker extends Component {

    rgbaToHex(color) {
        const r = Math.round((color.red || 0) * 255);
        const g = Math.round((color.green || 0) * 255);
        const b = Math.round((color.blue || 0) * 255);
        return '#' + [r, g, b].map(v => v.toString(16).padStart(2, '0')).join('');
    }

    hexToRgba(hex, alpha) {
        const r = parseInt(hex.slice(1, 3), 16) / 255;
        const g = parseInt(hex.slice(3, 5), 16) / 255;
        const b = parseInt(hex.slice(5, 7), 16) / 255;
        return { red: r, green: g, blue: b, alpha: alpha };
    }

    handleColorChange = (e) => {
        const alpha = this.props.color.alpha !== undefined ? this.props.color.alpha : 1;
        this.props.onChange(this.hexToRgba(e.target.value, alpha));
    }

    handleAlphaChange = (e) => {
        const { color } = this.props;
        this.props.onChange({
            red: color.red || 0,
            green: color.green || 0,
            blue: color.blue || 0,
            alpha: parseFloat(e.target.value)
        });
    }

    render() {
        const { color } = this.props;
        const hex = this.rgbaToHex(color);
        const alpha = color.alpha !== undefined ? color.alpha : 1;
        const r = Math.round((color.red || 0) * 255);
        const g = Math.round((color.green || 0) * 255);
        const b = Math.round((color.blue || 0) * 255);
        const rgbaStr = 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';

        const checkerboard = 'repeating-conic-gradient(#ccc 0% 25%, #fff 0% 50%) 0 0 / 10px 10px';

        return (
            <div>
                <div className="flex items-center space-x-2 mb-1">
                    <input
                        type="color"
                        value={hex}
                        onChange={this.handleColorChange}
                        className="w-8 h-8 border border-gray-300 rounded-sm cursor-pointer"
                    />
                    <div
                        className="w-8 h-8 rounded-sm border border-gray-300"
                        style={{ background: checkerboard }}
                        title={rgbaStr}
                    >
                        <div className="w-full h-full rounded-sm" style={{ backgroundColor: rgbaStr }} />
                    </div>
                    <span className="text-xs text-gray-500">{hex}</span>
                </div>
                <div className="flex items-center space-x-2">
                    <label className="text-xs text-gray-400 w-10">Alpha</label>
                    <input
                        type="range"
                        min="0"
                        max="1"
                        step="0.01"
                        value={alpha}
                        onChange={this.handleAlphaChange}
                        className="flex-1"
                    />
                    <span className="text-xs text-gray-500 w-8 text-right">{Math.round(alpha * 100)}%</span>
                </div>
            </div>
        );
    }
}

export default ColorPicker;
